import './remote-bootstrap';

export const isMainEntryActive = true;
